import React, { useEffect, useState, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import moEffectPdf from '../store';
import moSkin from '@/store/skin';
import moSkinPdf from '@/store/skinpdf';

interface IProps { }
interface IState { }

const TopContent = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { yearList, myIndustry } = moEffectPdf;

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section className="top-pdf-content">
      {/* <i className="iconfont icon-a-logoxinzhi logo-11" /> */}
      <img src={moSkinPdf.logo2} alt="" className='logo-11'/>
      <section className='detail'>
        <p className='top'><span>人效</span>及资源配置</p>
        <p className='mid'>{yearList[0]} - {yearList[yearList.length - 1]} 年报告</p>
        <p className='bot'><span />{myIndustry}</p>
      </section>
    </section>
  );
};

export default observer(TopContent);
